import LoadingButton from '@mui/lab/LoadingButton';

type ExecutiveReportDownloadButtonProps = {
  loading: boolean;
  onClickHandler: () => void;
  disabled?: boolean;
};

export const ExecutiveReportDownloadButton = ({
  loading,
  onClickHandler,
  disabled,
}: ExecutiveReportDownloadButtonProps) => (
  <LoadingButton
    onClick={onClickHandler}
    size="large"
    disabled={disabled}
    loadingPosition="start"
    loading={loading}
    // workaround to avoid loading icon overlap without a startIcon
    startIcon={loading ? '...' : undefined}
  >
    <span>Executive Report (.pptx)</span>
  </LoadingButton>
);
